var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "desp"
  }, [_c('div', {
    staticClass: "desp-header"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.companyDetailsTitle))]), _c('div', {
    staticClass: "opts"
  }, [(_vm.detail.applymentStatus === 'REVISING' || _vm.detail.applymentStatus === 'CORRECTED' || _vm.detail.applymentStatus === 'ILLEGAL' || _vm.detail.applymentStatus === 'AUDIT_FAIL' || _vm.detail.applymentStatus === 'REFUND_APPLY_DENY' || _vm.detail.applymentStatus === 'REFUND_APPLY_REJECT' || _vm.detail.applymentStatus === 'ACRA_REJECTED') && _vm.isApplymentAuth('company:coordinate') ? _c('el-button', {
    ref: "",
    on: {
      "click": function click($event) {
        return _vm.openEdit();
      }
    }
  }, [_vm._v(" Edit ")]) : _vm._e()], 1)]), _vm.isMalaysia ? [_c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Registered Address")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self no-event"
  }, [_c('el-radio-group', {
    attrs: {
      "value": _vm.detail.registeredOfficeType
    }
  }, [_vm.nativeRegisteredAddress.length ? _c('div', [_c('el-radio', {
    staticClass: "pt10 pb10",
    attrs: {
      "label": 1
    }
  }, [_c('span', [_vm._v("Consent to use EStar Business Sdn. Bhd. (\"EStar\")'s registration address")]), _vm.detail.registeredOfficeType === 1 ? _c('div', {
    staticClass: "mt6 ml24"
  }, [_c('el-radio-group', {
    attrs: {
      "value": _vm.detail.registeredOfficeId
    }
  }, _vm._l(_vm.nativeRegisteredAddress, function (office) {
    return _c('el-radio', {
      key: office.id,
      attrs: {
        "label": office.id
      }
    }, [_c('span', {
      staticClass: "native-addr-text"
    }, [_vm._v(_vm._s(_vm.formatNativeAddress(office)))])]);
  }), 1)], 1) : _vm._e()])], 1) : _vm._e(), _c('div', [_c('el-radio', {
    staticClass: "pt6",
    attrs: {
      "label": 2
    }
  }, [_c('span', [_vm._v("Use other registration address")]), _vm.detail.registeredOfficeType === 2 ? _c('div', {
    staticClass: "mt6 ml24"
  }, [_c('div', {
    staticClass: "native-addr-text"
  }, [_vm._v(" " + _vm._s(_vm.formatCustomRegisteredAddress(_vm.detail)) + " ")])]) : _vm._e()])], 1)])], 1)])]), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Service Address")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self no-event"
  }, [_c('el-radio-group', {
    attrs: {
      "value": _vm.detail.serviceAddressType
    }
  }, [_c('div', [_c('el-radio', {
    staticClass: "pt10 pb10",
    attrs: {
      "label": 1
    }
  }, [_vm._v("Same As Registered Address")])], 1), _c('div', [_c('el-radio', {
    staticClass: "pt6",
    attrs: {
      "label": 2
    }
  }, [_c('span', [_vm._v("Use other service address")]), _vm.detail.serviceAddressType === 2 ? _c('div', {
    staticClass: "mt6 ml24"
  }, [_c('div', {
    staticClass: "native-addr-text"
  }, [_vm._v(" " + _vm._s(_vm.formatCustomServiceAddress(_vm.detail)) + " ")])]) : _vm._e()])], 1)])], 1)])])] : _vm._e(), _vm.detail.businessType == 'COMPANY_INCORPORATION' ? [_c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Financial Year End (e.g. 31 December)")]), _c('div', {
    staticClass: "desp-item"
  }, [_vm.detail.financialYearEnd && _vm.detail.financialYearEnd.includes('/') ? _c('div', {
    staticClass: "desp-item-self"
  }, [_c('span', {
    staticClass: "mr20"
  }, [_vm._v("Month " + _vm._s(_vm.detail.financialYearEnd.split("/")[0]))]), _c('span', [_vm._v("Date " + _vm._s(_vm.detail.financialYearEnd.split("/")[1]))])]) : _vm._e()])]), _c('div', {
    staticClass: "desp-items-group"
  }, [_c('div', {
    staticClass: "desp-items-group-title"
  }, [_vm._v("Financial Year Period")]), _c('div', {
    staticClass: "desp-item"
  }, [_c('div', {
    staticClass: "desp-item-self"
  }, [_vm._v(_vm._s(_vm.detail.financialYearPeriod))])])])] : _vm._e(), _vm.editVisible ? _c('edit-modal', {
    ref: "editModal",
    attrs: {
      "businessType": _vm.detail.businessType,
      "country": _vm.country,
      "nativeRegisteredAddress": _vm.nativeRegisteredAddress
    }
  }) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }